import React, { useCallback } from 'react';
import { joinNames } from '../helpers';
import style from './style.module.scss';
export * from './NavigateLink';
export * from './ActionButton';

type ButtonType = 'primary' | 'secondary' | 'tertiary' | 'small-dismissable';

export type ButtonProps = {
    uiType?: ButtonType;
    disabled?: boolean;
    uiTestingId?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export function Button(props: ButtonProps) {
    const { className, uiType = 'primary', disabled, uiTestingId: nameForUiTesting, children, onClick, ...attr } = props;
    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => !disabled && typeof onClick == 'function' && onClick(e),
        [disabled, onClick]
    );
    return (
        <button
            data-nameforuitesting={nameForUiTesting}
            className={joinNames(className, getClass(uiType), getDisabledClass(disabled))}
            onClick={handleClick}
            disabled={disabled}
            {...attr}
        >
            {children}
        </button>
    );
}

function getClass(type: ButtonType): string {
    return type === 'primary'
        ? style['primary-btn']
        : type === 'secondary'
        ? style['secondary-btn']
        : type == 'tertiary'
        ? style['tertiary-btn']
        : style['small-dismissable-btn'];
}

function getDisabledClass(disabled?: boolean): string {
    return disabled ? style.disabled : '';
}

export default Button;
